export * from './watchListEntryTypes';


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/types/index.js